import { FC } from "react";
import { Column } from "react-table";

import { copy } from "shared/assets";
import { Plus, User } from "shared/assets/icons";
import { Button, Modal, Table, Title, IActionDropdownItem } from "shared/components";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";
import { isVenueDomain } from "shared/utils";
import { IEditorInvite, IVenue, IVenueUser } from "Venues/types";

export interface EditorsOverviewModalProps {
  title: string;
  venue: IVenue;
  handleClose: () => void;
  handleOpenEdit: () => void;
  showRemoveModal: (venueUser: IVenueUser) => void;
  showRevokeModal: (invite: IEditorInvite) => void;
}

export const EditorsOverviewModal: FC<EditorsOverviewModalProps> = ({
  title,
  venue,
  handleClose,
  handleOpenEdit,
  showRemoveModal,
  showRevokeModal,
}) => {
  const handleShowRemoveModalAction = (venueUserId: string): IActionDropdownItem[] => {
    const venueUser = venue?.users?.find(({ id }) => id === venueUserId);
    if (venue.users?.length !== 1 && venueUser)
      return [
        {
          label: copy.venueEditors.unlink.cta,
          handleClick: () => showRemoveModal(venueUser),
          dataTestId: "unlink_editor",
        },
      ];

    return [];
  };

  const handleShowRevokeModalAction = (inviteId: string): IActionDropdownItem[] => {
    const invite = venue?.invites?.find(({ id }) => id === inviteId);

    if (invite) {
      return [
        {
          label: copy.venueEditors.revoke.cta,
          handleClick: () => showRevokeModal(invite),
          dataTestId: "revoke_invite",
        },
      ];
    }

    return [];
  };

  return (
    <Modal handleClose={handleClose} title={`${copy.venueEditors.title} ${title}`} icon={User}>
      <Spacer size="l">
        <Button size="l" onClick={handleOpenEdit} data-testid="invite_editor_button">
          <Icon as={Plus} />
          <span>{copy.venueEditors.button}</span>
        </Button>

        <Title title={copy.venueEditors.registered} />
        <Table columns={columns} data={venue?.users} getRowActions={handleShowRemoveModalAction} />

        {isVenueDomain && !!venue.invites?.length && (
          <Spacer size="xs">
            <Title title={copy.venueEditors.pending} />
            <Table
              columns={pendingColumns}
              getRowActions={handleShowRevokeModalAction}
              data={venue.invites}
            />
          </Spacer>
        )}

        <Button theme={ITheme.secondary} onClick={handleClose}>
          {copy.actions.close}
        </Button>
      </Spacer>
    </Modal>
  );
};

const columns: Column[] = [
  {
    Header: copy.authFormFields.firstName,
    accessor: "firstname",
  },
  {
    Header: copy.authFormFields.lastName,
    accessor: "lastname",
  },
];

const pendingColumns: Column[] = [
  {
    Header: copy.authFormFields.email,
    accessor: "email",
  },
];
